firebird.factory('brandingService', [
    'helperService',
    'brandingStateService',
    'subscriptionService',
    function (helperService, brandingStateService, subscriptionService) {
        let rootSubscription;
        const service = {
            getResellerCode: getResellerCode,
            getCamaroAppName: getCamaroAppName,
            getAppFullName: getAppFullName,
            getProtocol: getProtocol,
            getImagePath: getImagePath,
            getAppLogo: getAppLogo,
            getHorizontalLogo: getHorizontalLogo,
            getBaseColor: getBaseColor,
            getDesktopNotificationIcon: getDesktopNotificationIcon,
            getBackgroundURL: getBackgroundURL,
            isSnapEngageWidgetVisible: isSnapEngageWidgetVisible,
            isAccountManagerAvailable: isAccountManagerAvailable,
            getResellerId: getResellerId,

            getUniteDtAppName: getUniteDtAppName,
            getUniteDownloadLink: getUniteDownloadLink,
            getUniteDtAppLogo: getUniteDtAppLogo,
            getMobileAppDownloadUrl: getMobileAppDownloadUrl,

            isAnymeetingDirect: isAnymeetingDirect,
            isPLR: isPLR,
            isUB: isUB,
            isPartner: isPartner
        };

        // extracted to branding-state.service.ts
        var resellerId;
        initSubscriptions();

        var resellers = {
            amdirect: {
                resellerCode: 'amdirect',
                appName: 'AnyMeeting',
                appFullName: 'Intermedia AnyMeeting',
                protocol: 'anymeeting://',
                imagePath: 'direct/',
                appLogo: 'img/redesign/branding_logo.svg',
                uniteRoomsAppLogo: 'img/redesign/unite-rooms-app/unite/app-logo.png',
                horizontalLogo: '/img/logos/horizontal.png',
                baseColor: '#0098DB',
                desktopNotificationLogo: 'img/icons/icon_im.png',
                backgroundURL: 'img/redesign/blue-gradient-background.svg',
                webinarBackgroundURL: 'img/redesign/blue-gradient-background.svg',
                uniteRoomsAppBackgroundURL: 'img/redesign/unite-rooms-app/background.jpg',
                snapEngageWidgetVisibility: true,

                uniteDtAppName: 'Unite',
                uniteDtAppLogo: 'img/redesign/unite-dt-logo-unite.svg',
                uniteDtMacOsDownloadUrl: 'https://www.intermedia.net/assets/apps/intermedia-unite.dmg',
                uniteDtWinDownloadUrl: 'https://www.intermedia.net/assets/apps/intermedia-unite.exe',
                mobileAppDownloadUrl: 'https://anymeetingapp.page.link/store',
                mobileAppDownloadUrlWithDetails:
                    'https://anymeetingapp.page.link/?link=https://www.anymeeting.com/__meetingIdentifier__&apn=net.intermedia.newmeeting&isi=1476514359&ibi=net.intermedia.anymeeting&efr=1'
            },
            direct: {
                resellerCode: 'direct',
                appName: 'AnyMeeting',
                appFullName: 'Intermedia AnyMeeting',
                protocol: 'anymeeting://',
                imagePath: 'direct/',
                appLogo: 'img/redesign/branding_logo.svg',
                uniteRoomsAppLogo: 'img/redesign/unite-rooms-app/unite/app-logo.png',
                horizontalLogo: '/img/logos/horizontal.png',
                baseColor: '#0098DB',
                desktopNotificationLogo: 'img/icons/icon_im.png',
                backgroundURL: 'img/redesign/blue-gradient-background.svg',
                webinarBackgroundURL: 'img/redesign/blue-gradient-background.svg',
                uniteRoomsAppBackgroundURL: 'img/redesign/unite-rooms-app/background.jpg',
                snapEngageWidgetVisibility: true,

                uniteDtAppName: 'Unite',
                uniteDtAppLogo: 'img/redesign/unite-dt-logo-unite.svg',
                uniteDtMacOsDownloadUrl: 'https://www.intermedia.net/assets/apps/intermedia-unite.dmg',
                uniteDtWinDownloadUrl: 'https://www.intermedia.net/assets/apps/intermedia-unite.exe',
                mobileAppDownloadUrl: 'https://anymeetingapp.page.link/store',
                mobileAppDownloadUrlWithDetails:
                    'https://anymeetingapp.page.link/?link=https://www.anymeeting.com/__meetingIdentifier__&apn=net.intermedia.newmeeting&isi=1476514359&ibi=net.intermedia.anymeeting&efr=1'
            },
            plr: {
                resellerCode: 'plr',
                appName: 'Online Meeting',
                appFullName: 'Online Meeting',
                protocol: 'gomeet://',
                imagePath: 'plr/',
                appLogo: 'img/redesign/online-meeting-logo.svg',
                uniteRoomsAppLogo: 'img/redesign/unite-rooms-app/elevate/app-logo.png',
                horizontalLogo: '/img/logos/horizontal-plr.png',
                baseColor: '#6DB33F',
                desktopNotificationLogo: 'img/icons/icon_plr.png',
                backgroundURL: 'img/redesign/blue-gradient-background.svg',
                webinarBackgroundURL: 'img/redesign/blue-gradient-background.svg',
                uniteRoomsAppBackgroundURL: 'img/redesign/unite-rooms-app/background.jpg',
                snapEngageWidgetVisibility: false,

                uniteDtAppName: 'Elevate UC',
                uniteDtAppLogo: 'img/redesign/unite-dt-logo-elevate.svg',
                uniteDtMacOsDownloadUrl: 'https://serverdata.net/elevateapps/apps/elevate-uc.dmg',
                uniteDtWinDownloadUrl: 'https://serverdata.net/elevateapps/apps/elevate-uc.exe',
                mobileAppDownloadUrl: 'https://gomeet.page.link/store',
                mobileAppDownloadUrlWithDetails:
                    'https://gomeet.page.link/?link=https://www.gomeet.com/__meetingIdentifier__&apn=net.serverdata.newmeeting&isi=1494540201&ibi=net.serverdata.onlinemeetingsfu'
            },
            univergeblue: {
                resellerCode: 'univergeblue',
                appName: 'UNIVERGE BLUE MEET',
                appFullName: 'UNIVERGE BLUE MEET',
                protocol: 'ubmeet://',
                imagePath: 'univergeblue/',
                appLogo: 'img/redesign/ub-meeting-logo.svg',
                uniteRoomsAppLogo: 'img/redesign/unite-rooms-app/blue/app-logo.png',
                horizontalLogo: '/img/logos/horizontal-ub.png',
                baseColor: '#0098DB',
                desktopNotificationLogo: 'img/icons/icon_ub.png',
                backgroundURL: 'img/redesign/blue-gradient-background.svg',
                webinarBackgroundURL: 'img/redesign/blue-gradient-background.svg',
                uniteRoomsAppBackgroundURL: 'img/backgrounds/blue_meet_bg.jpg',
                snapEngageWidgetVisibility: false,

                uniteDtAppName: 'UNIVERGE BLUE CONNECT',
                uniteDtAppLogo: 'img/redesign/unite-dt-logo-ub.svg',
                uniteDtMacOsDownloadUrl: 'https://univerge.blue/apps/univerge-blue-connect.dmg',
                uniteDtWinDownloadUrl: 'https://univerge.blue/apps/univerge-blue-connect.exe',
                mobileAppDownloadUrl: 'https://mobileuc.page.link/store',
                mobileAppDownloadUrlWithDetails:
                    'https://meetuniverge.page.link/?link=https://www.meetuniverge.blue/__meetingIdentifier__&apn=com.necam.mobilemeetings&isi=1502380837&ibi=com.necam.mobilemeetings'
            }
        };

        function getResellerCode() {
            let resellerCode;
            const resellerId = service.getResellerId();
            let locationHost = helperService.getLocationHost();
            if (locationHost.indexOf('gomeet') > -1) {
                resellerCode = 'plr';
            } else if (locationHost.indexOf('rambomeet') > -1 || locationHost.indexOf('meetuniverge') > -1) {
                resellerCode = 'univergeblue';
            } else if (resellerId === helperService.getResellerIdFromConfig('intermediaDirect')) {
                resellerCode = 'direct';
            } else if (resellerId === helperService.getResellerIdFromConfig('intermediaPLR')) {
                resellerCode = 'plr';
            } else if (resellerId === helperService.getResellerIdFromConfig('intermediaUB')) {
                resellerCode = 'univergeblue';
            } else {
                resellerCode = 'amdirect';
            }

            return resellerCode;
        }

        function getResellerInfo() {
            return resellers[getResellerCode()];
        }

        function getResellerId() {
            return resellerId;
        }

        function getCamaroAppName() {
            return getResellerInfo().appName;
        }

        function getAppFullName() {
            return getResellerInfo().appFullName;
        }

        function getUniteDtAppName() {
            return getResellerInfo().uniteDtAppName;
        }

        function getMobileAppDownloadUrl(meetingIdentifier) {
            if (meetingIdentifier) {
                let downloadUrl = getResellerInfo().mobileAppDownloadUrlWithDetails;
                return downloadUrl.replace('__meetingIdentifier__', meetingIdentifier);
            } else {
                return getResellerInfo().mobileAppDownloadUrl;
            }
        }

        function getProtocol() {
            return getResellerInfo().protocol;
        }

        function getImagePath() {
            return getResellerInfo().imagePath;
        }

        function getAppLogo() {
            if (helperService.isVideoRoomApplication()) {
                return getResellerInfo().uniteRoomsAppLogo;
            }

            return getResellerInfo().appLogo;
        }

        function getHorizontalLogo() {
            return getResellerInfo().horizontalLogo;
        }

        function getBaseColor() {
            return getResellerInfo().baseColor;
        }

        function getDesktopNotificationIcon() {
            return getResellerInfo().desktopNotificationLogo;
        }

        function getBackgroundURL(data) {
            if (data && data.isWebinar) {
                return getResellerInfo().webinarBackgroundURL;
            }
            if (helperService.isVideoRoomApplication()) {
                return getResellerInfo().uniteRoomsAppBackgroundURL;
            }

            return getResellerInfo().backgroundURL;
        }

        function isAnymeetingDirect() {
            return getResellerInfo().resellerCode === 'amdirect';
        }

        function isPLR() {
            return getResellerInfo().resellerCode === 'plr';
        }

        function isUB() {
            return getResellerInfo().resellerCode === 'univergeblue';
        }

        function isPartner() {
            var resellerCode = getResellerInfo().resellerCode;
            return resellerCode === 'plr' || resellerCode === 'univergeblue';
        }

        function isSnapEngageWidgetVisible() {
            return getResellerInfo().snapEngageWidgetVisibility;
        }

        function getUniteDownloadLink(isMacOs) {
            const resellerInfo = getResellerInfo();
            return isMacOs ? resellerInfo.uniteDtMacOsDownloadUrl : resellerInfo.uniteDtWinDownloadUrl;
        }

        function getUniteDtAppLogo() {
            let resellerInfo = getResellerInfo();
            return resellerInfo.uniteDtAppLogo;
        }

        function isAccountManagerAvailable() {
            return !service.isUB();
        }

        return service;

        function initSubscriptions() {
            rootSubscription = subscriptionService.createSubscription();
            rootSubscription.add(
                brandingStateService.resellerId$.subscribe(x => {
                    resellerId = x;
                })
            );
        }
    }
]);
